import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const impactDecisionStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            padding: "10px 50px 10px 50px",
        },
        icon: {
            marginLeft: "10px",
            cursor: "pointer",
        },
        title: { display: "flex", margin: "30px 0px 10px 0px" },

        smallIndicator: {
            height: "20vh",
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
        },
        button: {
            padding: "10px 40px 10px 40px",
            marginTop: "15px",
        },
        approveButton: {
            backgroundColor: "white",
            marginRight: "20px",
            color: "#008C34",
            border: "1px solid #008C34",
            "&:hover": {
                color: "white",
                backgroundColor: "#008C34",
            },
        },
        approveRecommendation: {
            backgroundColor: "#008C34",
            color: "black",
            "&:hover": {
                backgroundColor: "#008C34",
                color: "black",
            },
        },
        discardButton: {
            backgroundColor: "white",
            color: "#BE442A",
            border: "1px solid #BE442A",
            "&:hover": {
                color: "white",
                backgroundColor: "#BE442A",
            },
        },
        discardRecommendation: {
            backgroundColor: "#BE442A",
            color: "black",
            "&:hover": {
                backgroundColor: "#BE442A",
                color: "black",
            },
        },

        buttonsContainer: { margin: "20px 0px" },
        paragraph: {
            fontWeight: 550,
            fontSize: "18px",
            marginBottom: "15px",
            marginTop: "30px",
        },
        hide: {
            display: "none",
        },

        tooltip: {
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            padding: "20px",
            borderRadius: "0px",
            maxWidth: "180px",
            maxHeight: "400px",
            position: "relative",
            left: "100%",
            top: -200,
        },
        tooltipText: { fontSize: "14px", lineHeight: "16.52px" },
        tooltipTitle: {
            fontSize: "18px",
            lineHeight: "18px",
            fontWeight: 500,
        },

        selectContainer: {
            margin: "0px 0px 10px 0px",
        },
    })
);
